import { Patient } from 'src/interfaces/patient';

/** Applied to order subtotal when every line item has a patient */
export const PATIENT_ORDER_DISCOUNT_PERCENT = 5;

export function formatPatientName(patient: Patient | null | undefined): string {
  if (!patient) {
    return '';
  }
  return [patient.first_name, patient.last_name].filter(Boolean).join(' ').trim();
}

export function formatPatientDob(patient: Patient | null | undefined): string {
  const raw = patient?.date_of_birth?.trim() ?? '';
  if (!raw) {
    return '';
  }
  const isoDate = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  return isoDate ? isoDate[1] : raw;
}

/** Single-line label for PDF table cells */
export function formatPatientCell(patient: Patient | null | undefined): string {
  if (!patient?.first_name) {
    return '-';
  }
  return `${formatPatientName(patient)} (${formatPatientDob(patient)})`;
}

function toNumber(value: number | string | null | undefined): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function resolvePatientDiscountAmount(
  subtotal: number,
  patientDiscountPercent: number | string | null | undefined,
  patientDiscountAmount: number | string | null | undefined
): number {
  const amount = toNumber(patientDiscountAmount);
  if (amount > 0) {
    return amount;
  }
  const percent = toNumber(patientDiscountPercent);
  return percent > 0 ? subtotal * (percent / 100) : 0;
}

export function resolvePatientDiscountPercent(
  patientDiscountPercent: number | string | null | undefined,
  patientDiscountAmount: number | string | null | undefined
): number {
  if (toNumber(patientDiscountAmount) > 0) {
    const percent = toNumber(patientDiscountPercent);
    return percent > 0 ? percent : PATIENT_ORDER_DISCOUNT_PERCENT;
  }
  return 0;
}
